module.exports = __webpack_public_path__ + "assets/img/a2c98b4f98d0865d10e1d0709393a340.png";